module.exports = __webpack_public_path__ + "img/logo.769d65a3.png";